<template>
	<div class="articleList table-responsive">
		<table>
			<thead>
				<tr>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Name</span>
							<div class="ml-auto">
								<form :action="endPoint" method="GET" ref="NameSort">
									<input type="hidden" name="filter" v-model="urlParams.filter">
									<input v-if="urlParams.sort === 'desc-first_name'" type="hidden" name="sort" value="asc-first_name">
									<input v-else type="hidden" name="sort" value="desc-first_name">

									<i v-if="urlParams.sort === 'desc-first_name'" class="fas fa-sort-alpha-up" @click="sortTable('NameSort')"></i>
									<i v-else class="fas fa-sort-alpha-down" @click="sortTable('NameSort')"></i>
								</form>
							</div>
						</div>
					</th>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Email Address</span>
							<div class="ml-auto">
								<form :action="endPoint" method="GET" ref="EmailSort">
									<input type="hidden" name="filter" v-model="urlParams.filter">
									<input v-if="urlParams.sort === 'desc-email'" type="hidden" name="sort" value="asc-email">
									<input v-else type="hidden" name="sort" value="desc-email">

									<i v-if="urlParams.sort === 'desc-email'" class="fas fa-sort-alpha-up" @click="sortTable('EmailSort')"></i>
									<i v-else class="fas fa-sort-alpha-down" @click="sortTable('EmailSort')"></i>
								</form>
							</div>
						</div>
					</th>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Last Updated</span>
							<div class="ml-auto">
								<form :action="endPoint" method="GET" ref="DateSort">
									<input type="hidden" name="filter" v-model="urlParams.filter">
									<input v-if="urlParams.sort === 'desc-updated_at'" type="hidden" name="sort" value="asc-updated_at">
									<input v-else type="hidden" name="sort" value="desc-updated_at">

									<i v-if="urlParams.sort === 'desc-updated_at'" class="fas fa-sort-alpha-up" @click="sortTable('DateSort')"></i>
									<i v-else class="fas fa-sort-alpha-down" @click="sortTable('DateSort')"></i>
								</form>
							</div>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<user-item v-for="item in userList"
						   :key="item.id"
						   :data-user="item"
				></user-item>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		props: {
			dataUserList: {
				type: Array,
			},
			dataEndpoint: {
				type: String
			},
			dataUrlParams: {
				type: Object,
				required: false
			},
		},
		data() {
			return {
				userList: this.dataUserList,
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || [],
			}
		},
		methods: {
			sortTable: function (form) {
				$('input, select').each(function (_, inp) {
					if ($(inp).val() === '' || $(inp).val() === null)
						inp.disabled = true;
				});
				this.$refs[form].submit();
			}
		}
	}
</script>
